var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BsCheckbox',{staticClass:"checkbox",attrs:{"inline":"","tristate":""},model:{value:(_vm.modelProxy),callback:function ($$v) {_vm.modelProxy=$$v},expression:"modelProxy"}})}
var staticRenderFns = []

export { render, staticRenderFns }